interface ScrollToElementParams {
  offset?: number;
  behavior?: ScrollBehavior;
}

const defaultParams: ScrollToElementParams = {
  offset: 0,
  behavior: 'smooth',
};

const scrollToElement = (id: string, params: ScrollToElementParams = defaultParams) => {
  const { offset, behavior } = { ...defaultParams, ...params };
  const element = document.getElementById(id);
  if (!element) return;

  const y = element.getBoundingClientRect().top + window.pageYOffset + offset;

  window.scrollTo({ top: y, behavior });
};

export default scrollToElement;
